<template>
  <p class="text-sm leading-snug text-grey text-opacity-40 mb-6">
    Documents in this section will be kept for 30 days before being permanently deleted.
  </p>
  <div class="w-full grid grid-cols-5 gap-5">
    <button
      v-for="(document, index) in documents"
      :key="index"
      class="border-dashed border-2 border-black bg-[#fafafa] !text-black text-opacity-90 rounded-lg shadow-lg cursor-default"
    >
      <div class="p-3 flex flex-col items-center">
        <span class="text-center">
          {{ document.title }}
        </span>
      </div>

      <hr class="border-grey" />

      <div class="p-5 flex flex-col items-center">
        <span class="text-center text-xs text-grey text-opacity-10"
          >Last edit {{ document.date }}</span
        >
      </div>

      <hr class="border-grey" />

      <div class="p-3 flex items-center justify-center w-full">
        <div
          @click="restoreDocument(document.id)"
          class="w-1/2 flex flex-col items-center justify-center cursor-pointer"
        >
          <Icon :icon="'ant-design:reload-outlined'" class="text-xl" />
        </div>
        <span class="text-grey text-opacity-10">|</span>
        <TlPopConfirm
          title="Are you sure you want to permanently delete this document?"
          okText="Yes, Delete"
          cancelText="No"
          @confirm="deleteDocument(document.id)"
        >
          <div class="w-1/2 flex flex-col items-center justify-center cursor-pointer">
            <Icon :icon="'ant-design:delete-outlined'" class="text-xl" color="#FF4D4F" />
          </div>
        </TlPopConfirm>
      </div>
    </button>

    <div v-if="!documents.length" class="grid place-items-center content-center">
      <figure class="mx-auto max-w-[100px] w-[150px] aspect-square">
        <img src="@/assets/icons/Empty.svg" alt="Empty" class="w-full h-full object-contain" />
      </figure>

      <span class="text-sm leading-snug text-grey text-opacity-40">Empty</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { Icon } from '@iconify/vue';
import { Watch } from 'vue-property-decorator';
import { fetchDocuments, deleteDocument, restoreDocument } from '../../actions/document';
import TlPopConfirm from '@/components/global/TlPopConfirm.vue';
import { usePayloadStore } from '@/stores/payload';
import Message from 'antd-message';

@Options({
  components: {
    TlPopConfirm,
    Icon
  }
})
export default class Trash extends Vue {
  mounted() {
    this.getDocuments();
  }
  private payloadStore = usePayloadStore();

  public loadingResponse = false;

  public documents: any = [];

  public getDocuments() {
    this.payloadStore.change({ loadingResponse: true });
    fetchDocuments()
      .then((res: any) => {
        this.documents = res.filter((e: any) => e.is_deleted);
        this.payloadStore.change({ loadingResponse: false });
      })
      .catch((err) => {
        this.payloadStore.change({ loadingResponse: false });
      });
  }

  public restoreDocument(id: string) {
    this.payloadStore.change({ loadingResponse: true });
    restoreDocument(id)
      .then((res: any) => {
        Message.success('Document restored successfully');
        this.getDocuments();
        this.payloadStore.change({ loadingResponse: false });
      })
      .catch((err) => {
        console.log(err);
        Message.error('Could not restore document');
        this.payloadStore.change({ loadingResponse: false });
      });
  }

  public deleteDocument(id: string) {
    return new Promise((resolve) => {
      deleteDocument(id)
        .then((res: any) => {
          this.getDocuments();
          Message.success('Document was deleted successfully');
          resolve(true);
        })
        .catch((err) => {
          this.loadingResponse = false;
          Message.error('Document could not be deleted. Please try again later');
          resolve(true);
        });
    });
  }
}
</script>
